import PropTypes from 'prop-types'
import WorkflowSection from '../Section/WorkflowSection'
import '../Section/section.css'
import WorkflowButton from '../Section/WorkflowButton'
import { WorkflowButtonStates } from '../Section/WorkflowButtonStates'
import { useTicketType, ValidTicketTypes } from '../../../hooks/useTicketTypeHook';
import WorkflowButtonMaterial from '../Section/WorkflowButtonMaterial';

const DownloadReturnSection = ({ taxState, onWorkflowButtonAction, section }) => {
    const validTicketTypes = ValidTicketTypes;
    let { ticketType } = useTicketType(taxState)
    let keySuffix = 'WF';
    return (
        <WorkflowSection titleKey=''
            titleKeyProps={{ TaxYear: taxState.taxYear }} canClose={false}
            isAlternate={false} ticketType={taxState.ticket_type} section={section}>

            {ticketType.toLowerCase() === validTicketTypes.RTE
            ? <WorkflowButtonMaterial
                buttonKey="download"
                text={`WorkflowPanel.download.title.${keySuffix}`}
                textProps={{ TaxYear: taxState.taxYear }}
                icon="fa-download"
                showChevron = 'true'
                ticketType={ticketType}
                onClick={() => onWorkflowButtonAction('download', taxState.taxYear)} />

            : <WorkflowButton
                buttonKey="download"
                name="download"
                buttonState={WorkflowButtonStates.SHOW}
                icon="fa-download"
                text={`WorkflowPanel.download.title.${keySuffix}`}
                textProps={{ TaxYear: taxState.taxYear }}
                ticketType={ticketType}
                onClick={() => onWorkflowButtonAction('download', taxState.taxYear)}
                onFadeOut={() => { }} />}
        </WorkflowSection>
    );
};

DownloadReturnSection.propTypes = {
    taxState: PropTypes.shape({
        taxYear: PropTypes.number.isRequired,
        coupled: PropTypes.bool.isRequired,
        primary_province: PropTypes.string,
        primary_firstName: PropTypes.string.isRequired,
        spouse_province: PropTypes.string,
        spouse_firstName: PropTypes.string,
        subTotal: PropTypes.number,
        tenderTotal: PropTypes.number
    }),
    currentYear: PropTypes.number.isRequired,
    onWorkflowButtonAction: PropTypes.func.isRequired
}

export default DownloadReturnSection;

